import "./App.css";
import LandingPage from "./pages/LandingPage";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import SingleTrip from "./pages/SingleTrip";
import BookingPage from "./pages/BookingPage";
import Payment from "./pages/Payment";
import ScrollToTop from "./components/ScrollToTop";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./pages/admin/ProtectedRoute";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminLogin from "./pages/admin/AdminLogin";
import AddTrip from "./pages/admin/AddTrip";
import CategoryListPage from "./pages/CategoryListPage";
import Spinner from "./components/Spinner";
import { SetTrip } from "./redux/features/tripSlice";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useEffect, useState } from "react";
import AllAdminTrips from "./pages/admin/AllAdminTrips";
import Inquiry from "./pages/admin/Inquiry";
import Banner from "./pages/admin/Banner";
import Support from "./pages/admin/Support";
import AddCityImage from "./pages/admin/AddCityImage";
import PaymentPage from "./pages/payment/PaymentPage";
import Success from "./pages/payment/Success";
import Failure from "./pages/payment/Failure";
import TermsPage from "./pages/TermsPage";
import Privacy from "./pages/Privacy";
import Refund from "./pages/Refund";
import BookingList from "./pages/admin/BookingList";
import BookingTrip from "./pages/admin/BookingTrip";
import EditTrip from "./pages/admin/EditTrip";
import WebsiteUpdate from "./pages/admin/component/WebsiteUpdate";
import Career from "./pages/Career";
import HomeCategory from "./pages/admin/HomeCategory";
import AddCategory from "./pages/admin/AddCategory";
import AdminCareer from "./pages/admin/AdminCareer";
import Application from "./pages/admin/Application";
import AddPdf from "./pages/admin/AddPdf";
import AdminBlog from "./pages/admin/AdminBlog";
import CustomisedListPage from "./pages/CustomisedListPage";
import AddCouponCode from "./pages/admin/AddCouponCode";
import CategoryBlogPage from "./pages/CategoryBlogPage";
import PhonePeIntegration from "./components/PhonePeIntegration";
import AdminAddReviews from "./pages/admin/AdminAddReviews";
import AdminAddMembers from "./pages/admin/component/AdminAddMembers";
import AdminEditBlog from "./pages/admin/AdminEditBlog";
import Website from "./pages/Website";
import NYETrips from "./pages/nyetrips";
import ReviewPage from "./pages/reviewpage";
import AdminAddTravelTheme from "./pages/admin/AdminAddTravelTheme";
import ThankYouPage from "./pages/ThankYouPage";
import Destinations from "./pages/Destinations";
import CustomiseTrip from "./pages/CustomiseTrip";
import DynamicLandingPage from "./pages/DynamicLandingPage";
import TravelThemePage from "./pages/TravelThemePage";
import NewYearTripsLandingPage from "./pages/NewYearTripsLandingPage";
import { AuthProvider } from "./context/AuthContext";
import ResetPasswordModal from "./components/AuthModal/ResetPasswordModal";
import AddOfflineBooking from "./pages/admin/AddOfflineBooking";
import VerifyEmail from "./components/AuthModal/VerifyEmail";
import Profile from "./components/AuthModal/Profile";
import Account from "./components/AuthModal/Account";
import PostponeRequests from "./pages/admin/PostponeRequests";

function App() {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);

  // get All Selected Home Page Category
  const getSelectedHomeCategory = () => {
    axios.get(`api/homecategory/get-home-category`).then((res) => {
      setLoader(res.data.data[0]?.customised);
    });
  };
// const getSelectedHomeCategory = async () => {
//   try {
//     const res = await axios.get(`api/homecategory/get-home-category`);
//     const dataArr = res?.data?.data;

//     if (Array.isArray(dataArr) && dataArr.length > 0) {
//       setLoader(dataArr[0]?.customised || false);
//     } else {
//       setLoader(false); // default value to avoid crash
//     }
//   } catch (error) {
//     console.error("Error fetching home category:", error);
//     setLoader(false); // prevent crash on API failure
//   }
// };

  const AllTrips = async () => {
    await axios
      .get(`api/trips/get-all-trips`)
      .then((res) => {
        dispatch(SetTrip(res.data.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    AllTrips();
    getSelectedHomeCategory();
  }, []);

  return (
      <AuthProvider>

    <BrowserRouter>
      <ScrollToTop />
      {loader ? (
        <Routes>
          <Route exact path="/" element={<Spinner />} />
          <Route exact path="/server-error" element={<Website />} />
        </Routes>
      ) : (
        <main>
          <Routes>
            {/* admin routes */}
            <Route
              exact
              path="/admin-reviews"
              element={
                <ProtectedRoute adminDashboard="adminDashboard">
                  <AdminAddReviews />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/admin-dashboard"
              element={
                <ProtectedRoute adminDashboard="adminDashboard">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route exact path="/login" element={<AdminLogin />} />
            <Route
              exact
              path="/add-trip"
              element={
                <ProtectedRoute addTrip={true}>
                  <AddTrip />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/admin-career"
              element={
                <ProtectedRoute adminCareer={true}>
                  <AdminCareer />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/admin-career/:title"
              element={
                <ProtectedRoute adminCareer={true}>
                  <AdminCareer />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/admin-blog"
              element={
                <ProtectedRoute adminBlog={true}>
                  <AdminBlog />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/admin-edit-blog/:id?"
              element={
                <ProtectedRoute adminEditBlog={true}>
                  <AdminEditBlog />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/admin-about"
              element={
                <ProtectedRoute adminBlog={true}>
                  <AdminAddMembers />
                </ProtectedRoute>
              }
            /><Route
  exact
  path="/add-travel-theme"
  element={
    <ProtectedRoute addTravelTheme={true}>
      <AdminAddTravelTheme />
    </ProtectedRoute>
  }
/>

            <Route
              exact
              path="/job-application"
              element={
                <ProtectedRoute application={true}>
                  <Application />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/edit-trip/:id"
              element={
                <ProtectedRoute editTrip={true}>
                  <EditTrip />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/all-trips"
              element={
                <ProtectedRoute allAdminTrips={true}>
                  <AllAdminTrips />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/customer-inquiry"
              element={
                <ProtectedRoute inquiry={true}>
                  <Inquiry />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/promotional-banner"
              element={
                <ProtectedRoute banner={true}>
                  <Banner />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/add-city-image"
              element={
                <ProtectedRoute addCityImage={true}>
                  <AddCityImage />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/add-coupon-code"
              element={
                <ProtectedRoute addCouponCode={true}>
                  <AddCouponCode />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/add-home-category"
              element={
                <ProtectedRoute homeCategory={true}>
                  <HomeCategory />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/add-category"
              element={
                <ProtectedRoute addCategory={true}>
                  <AddCategory />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/cutomer-support"
              element={
                <ProtectedRoute support={true}>
                  <Support />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/booking-list"
              element={
                <ProtectedRoute bookingList={true}>
                  <BookingList />
                </ProtectedRoute>
              }
            />
            <Route
  exact
  path="/add-offline-booking"
  element={
    <ProtectedRoute bookingList={true}>
      <AddOfflineBooking />
    </ProtectedRoute>
  }
/>
<Route
  exact
  path="/postpone-requests"
  element={
    <ProtectedRoute bookingList={true}>
      <PostponeRequests />
    </ProtectedRoute>
  }
/>

            <Route
              exact
              path="/booking-trip/:id"
              element={
                <ProtectedRoute bookingTrip={true}>
                  <BookingTrip />
                </ProtectedRoute>
              }
            />
            <Route exact path="/check-connection" element={<WebsiteUpdate />} />
            <Route exact path="/add-pdf" element={<AddPdf />} />
            {/* end admin routes */}

            {/* payment route */}
            <Route exact path="/payment-page" element={<PaymentPage />} />
            {/* end payment route */}

            {/* customer routes */}
            <Route exact path="/" element={<LandingPage />} />
            <Route exact path="/about" element={<About />} />
            <Route exact path="/contact" element={<Contact />} />
            <Route exact path="/career" element={<Career />} />
            <Route exact path="/career/:title" element={<Career />} />
            <Route exact path="/blog" element={<Blog />} />
            <Route
              exact
              path="/blog/:category"
              element={<CategoryBlogPage />}
            />
            <Route
              exact
              path="/Trending-Blogs/:title"
              element={<CategoryBlogPage />}
            />
            <Route exact path="/server-error" element={<Website />} />
            <Route
              exact
              path="/Latest-Blogs/:title"
              element={<CategoryBlogPage />}
            />
            <Route
              exact
              path="/Informational-Blogs/:title"
              element={<CategoryBlogPage />}
            />
            <Route
              exact
              path="/category/:category"
              element={<CategoryListPage />}
            />
            <Route
              exact
              path="/customised/:category/"
              element={<CustomisedListPage />}
            />

            <Route
  exact
  path="/travel-theme/:theme"
  element={<TravelThemePage />}
/>

            <Route exact path="/trip/:id" element={<SingleTrip />} />
            <Route exact path="/book/:id" element={<SingleTrip />} />
            <Route exact path="/payment" element={<Payment />} />
            <Route exact path="/success/:id" element={<Success />} />
            <Route exact path="/failure/:id" element={<Failure />} />
            <Route exact path="/terms-and-conditions" element={<TermsPage />} />
            <Route exact path="/privacy-policy" element={<Privacy />} />
            <Route exact path="/refund-policy" element={<Refund />} />
            <Route exact path="/phonepe" element={<PhonePeIntegration />} />
            <Route exact path="/nye-trips" element={<NYETrips />} />
            <Route exact path="/nye-trips/category/:category" element={<CategoryListPage />} />

<Route exact path="/reviews" element={<ReviewPage />} />
<Route exact path="/thank-you" element={<ThankYouPage />} />
<Route exact path="/all-destinations" element={<Destinations />} />
<Route path="/customise-trip" element={<CustomiseTrip />} />
{/* <Route path="/landing-page-all-trips" element={<DynamicLandingPage />} /> */}
{/* <Route path="/landing-page/:pageSlug" element={<DynamicLandingPage />} /> */}
<Route
  path="/landing-page-domestic-trips"
  element={<DynamicLandingPage pageSlug="domestic-trips" />}
/>
<Route
  path="/landing-page-international-trips"
  element={<DynamicLandingPage pageSlug="international-trips" />}
/>
<Route
  path="/landing-page-nye-trips"
  element={<DynamicLandingPage pageSlug="nye-trips" />}
/>
<Route
  path="/landing-page-nye-domestic-trips"
  element={<DynamicLandingPage pageSlug="nye-domestic-trips" />}
/>
<Route
  path="/landing-page-all-trips"
  element={<DynamicLandingPage pageSlug="all-trips" />}
/>
<Route
  path="/landing-page-nye-international-trips"
  element={<DynamicLandingPage pageSlug="nye-international-trips" />}
/>
    <Route
  path="/landing-page-ladakh-winter-trip"
  element={<DynamicLandingPage pageSlug="ladakh-winter-trip" />}
/>
   <Route
  path="/landing-page-summer-bike-trips"
  element={<DynamicLandingPage pageSlug="summer-bike-trips" />}
/>
  <Route
  path="/landing-page-ladakh-summer-trip-2026"
  element={<DynamicLandingPage pageSlug="ladakh-summer-trip-2026" />}
/>
 <Route
  path="/landing-page-kashmir-winter-trip"
  element={<DynamicLandingPage pageSlug="kashmir-winter-trip" />}
/>
<Route exact path="/newyear-trips" element={<NewYearTripsLandingPage />} />
<Route exact path="/reset-password/:token" element={<ResetPasswordModal />} />
<Route path="/verify-email/:token" element={<VerifyEmail />} />
<Route exact path="/account" element={<Account />} />

            {/* end customer routes */}
          </Routes>
        </main>
      )}
    </BrowserRouter>
      </AuthProvider>

  );
}

export default App;
